import { ArrowRightIcon } from 'lucide-react'

import { useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { Button, usePageTitle } from 'slab'

import { CenteredLayout } from '../CenteredLayout'

export function WelcomeIntroPage () {
  usePageTitle('Welcome')

  const { navigateToNextStep } = useOnboardingStep()

  return (
    <CenteredLayout verticallyCentered>
      <CenteredLayout.Header
        heading='Thatch is a new way of doing healthcare that both you and your employees will love'
        subheading='Offer flexible health benefits with predictable, scalable costs.'
      />
      <CenteredLayout.Buttons>
        <Button
          variant='primary'
          onClick={navigateToNextStep}
          size='large'
          width='auto'
          rightIcon={ArrowRightIcon}
        >
          Let's get started
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
